import { render, staticRenderFns } from "./SidebarSearchBox.vue?vue&type=template&id=159a4a5a&scoped=true"
import script from "./SidebarSearchBox.vue?vue&type=script&lang=js"
export * from "./SidebarSearchBox.vue?vue&type=script&lang=js"
import style0 from "./SidebarSearchBox.vue?vue&type=style&index=0&id=159a4a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159a4a5a",
  null
  
)

export default component.exports